module.exports = __webpack_public_path__ + "img/Weapon_262.07eaad3f.png";